export function Brush02Icon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      id="img"
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      {...props}
    >
      <path
        d="M8.99997 11.2214L12.7778 14.9992M7.97485 20.9741C6.60801 22.3409 4 21.9992 2 21.9992C3.0251 19.9992 1.65827 17.3912 3.0251 16.0243C4.39194 14.6575 6.60801 14.6575 7.97485 16.0243C9.34168 17.3912 9.34168 19.6072 7.97485 20.9741ZM11.9216 15.9238L21.0587 6.05574C21.8635 5.18657 21.8375 3.83679 20.9999 2.9992C20.1624 2.1616 18.8126 2.13565 17.9434 2.94044L8.07534 12.0775C7.5654 12.5497 7.31043 12.7858 7.16173 13.0376C6.80514 13.6413 6.79079 14.3877 7.12391 15.0048C7.26283 15.2621 7.50853 15.5078 7.99995 15.9992C8.49136 16.4906 8.73707 16.7363 8.99438 16.8752C9.6114 17.2083 10.3578 17.194 10.9616 16.8374C11.2134 16.6887 11.4494 16.4337 11.9216 15.9238Z"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
